import { logger } from "@/utils/logger";
import { LeadPushtoD2C } from './leadPushUtils';
import { processAutoLeadFromContact } from './autoLeadFromContact';

// Debug function to test lead pushing manually
export const testLeadPush = async () => {
  logger.log('=== MANUAL LEAD PUSH TEST ===');
  
  const testContactData = {
    Name: 'Test User',
    Phone: '5145551234',
    Email: 'test@example.com'
  };
  
  logger.log('Testing with data:', testContactData);
  
  try {
    const result = await LeadPushtoD2C(testContactData);
    logger.log('Test result:', result);
    return result;
  } catch (error) {
    logger.error('Test failed:', error);
    return false;
  }
};

// Test function for auto-lead from Contact object in AI response
export const testAutoLeadFromPayload = async (payload: any) => {
  logger.log('=== TESTING AUTO LEAD FROM AI PAYLOAD ===');
  
  if (!payload.Contact) {
    logger.error('❌ No Contact object in payload');
    return false;
  }
  
  try {
    const result = await processAutoLeadFromContact(
      payload.Contact,
      payload.Interest
    );
    logger.log('Result:', result);
    return result;
  } catch (error) {
    logger.error('Test failed:', error);
    return { success: false };
  }
};

// Debug function to enable form emails debugging
export const enableFormEmailsDebug = () => {
  localStorage.setItem('debug_form_emails', 'true');
  logger.log('🔍 Form emails debug mode ENABLED - modal will show on next form submission');
};

export const disableFormEmailsDebug = () => {
  localStorage.removeItem('debug_form_emails');
  logger.log('🔍 Form emails debug mode DISABLED');
};

// Make it available globally for console testing
if (typeof window !== 'undefined') {
  logger.log('🔧 Loading leadPushDebug utilities...');
  (window as any).testLeadPush = testLeadPush;
  (window as any).testAutoLeadFromPayload = testAutoLeadFromPayload;
  (window as any).enableFormEmailsDebug = enableFormEmailsDebug;
  (window as any).disableFormEmailsDebug = disableFormEmailsDebug;
  logger.log('✅ Debug functions loaded and available:');
  logger.log('- window.testLeadPush()');
  logger.log('- window.testAutoLeadFromPayload(payload)');
  logger.log('- window.enableFormEmailsDebug()');
  logger.log('- window.disableFormEmailsDebug()');
  logger.log('Test that function exists:', typeof (window as any).testAutoLeadFromPayload);
}
